import config from '../config';

export const head = {
  home: {
    title: 'Дофаминка',
    url: config.paths.home
  },
};
